import { render } from "./MDataTableTop.vue?vue&type=template&id=79d78b55"
import script from "./MDataTableTop.vue?vue&type=script&lang=js"
export * from "./MDataTableTop.vue?vue&type=script&lang=js"

import "./MDataTableTop.vue?vue&type=style&index=0&id=79d78b55&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__